import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/campanha-envio'
const APICore = process.env.APIBaseURLCore

const GetAllCampanhaReport = (dataFilters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, dataFilters, config)
const ExportAllCampanhaReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)

const ReportEnvioCampanhaRepository = {
  GetAllCampanhaReport,
  ExportAllCampanhaReport
}

export default ReportEnvioCampanhaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/reports/reportEnvioCampanha.js